/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';

import If from '@components/shared/conditional/If/If';
import {
  getResizedImageUrl,
  appendThumborTransformQueryString,
} from '@lib/image';
import getBoardName from '@lib/board/getBoardName';
import styles from './styles.module.scss';
import SaveIcon from './save-icon.svg';

const cx = classNames.bind(styles);

const getSlideStyles = (isAnimating) => {
  return cx({
    Slide: true,
    isAnimated: isAnimating,
  });
};

const Slide = (props) => {
  const {
    offset, isAnimating, first, last, listId, board, onSaveAsset, savedAssets,
  } = props;

  if (!board) {
    return null;
  }

  const mainAsset = board?.mainBoardAsset?.asset;
  const isSaved = savedAssets && mainAsset && !!savedAssets[mainAsset.id];

  const resizedImage = getResizedImageUrl({
    url: mainAsset?.url,
    // eslint-disable-next-line no-restricted-globals
    height: Math.ceil(screen.height * window.devicePixelRatio),
    // eslint-disable-next-line no-restricted-globals
    width: Math.ceil(screen.width * 1.5 * window.devicePixelRatio),
    quality: 50,
  });

  let top = 0;
  if (first) {
    top = -window.innerHeight;
  }
  if (last) {
    top = window.innerHeight;
  }

  return (
    <div
      className={ getSlideStyles(isAnimating, first, last) }
      style={{
        backgroundImage: `url('${resizedImage}')`,
        transform: `translate(${offset.x}px, ${offset.y}px)`,
        height: window.innerHeight,
        top,
      }}
    >

      <Link href={ `/interior-design-ideas/design-board/${board.id}` }>
        <a
          className={ styles.LinkUnderlay }
        />
      </Link>

      <div className={ styles.GradientBg } />

      <button
        className={ styles.SaveButton }
        onClick={ () => onSaveAsset(board, mainAsset, listId) }
        type="button"
      >
        <div
          className={ `
            ${styles.SaveIcon}
            ${isSaved ? styles.isSaved : ''}
          ` }
        >
          <SaveIcon />
        </div>
        <div>
          {isSaved ? 'SAVED' : 'SAVE'}
        </div>
      </button>

      <div className={ styles.Details }>
        <Link href={ `/interior-design-ideas/design-board/${board.id}` }>
          <a>
            <div className={ styles.Name }>
              {getBoardName(
                board?.publicName,
                board?.subStyles,
                board?.roomType?.type,
              )}
            </div>
          </a>
        </Link>

        <div className={ styles.BottomDetails }>
          {board.designer && (
            <>
              <If condition={ board.designer.vanityId }>
                <a
                  className={ styles.Designer }
                  href={ `/interior-designers/${board.designer.vanityId}` }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img
                    alt="designer"
                    className={ styles.DesignerImage }
                    src={ appendThumborTransformQueryString({
                      url: board.designer.photo,
                      height: 44,
                      width: 44,
                    }) }
                  />
                  Designed by {board.designer.firstName}
                </a>
              </If>
              <If condition={ !board.designer.vanityId }>
                <div className={ styles.Designer }>
                  <img
                    alt="designer"
                    className={ styles.DesignerImage }
                    src={ getResizedImageUrl({
                      url: board.designer.photo,
                      height: 44,
                      width: 44,
                    }) }
                  />
                  Designed by {board.designer.firstName}
                </div>
              </If>
            </>
          )}

          <Link href={ `/interior-design-ideas/design-board/${board.id}` }>
            <a
              className={ styles.ProductsLink }
            >
              View {board.boardProductCount} Products
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Slide;
